module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keywords":"Keywords","keywords_placeholder":"Add keywords.."},"fr":{"keywords":"Mots-clés","keywords_placeholder":"Ajouter des mots-clés.."},"de":{"keywords":"Schlüsselwörter","keywords_placeholder":"Schlüsselwörter hinzufügen.."}}')
  delete Component.options._Ctor
}
